import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Chip from "@mui/material/Chip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import {
  getServiceList,
  postService,
  serviceUpdating,
} from "actions/serviceActions";
import MDActionConfigurator from "components/MDActionConfigurator";

function Services() {
  const configuratorRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    mainService: "",
    service: "",
    description: "",
  });

  const listServices = useSelector((state) => state.listServices);
  const { servicesList } = listServices;

  useEffect(() => {
    if (servicesList?.length === 0) {
      dispatch(getServiceList());
    }
  }, [dispatch, servicesList?.length]);

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const groupByMainService = (data) => {
    const groupedData = {};

    data?.forEach((service) => {
      const { mainService, ...rest } = service;
      if (!groupedData[mainService]) {
        groupedData[mainService] = [];
      }
      groupedData[mainService].push({ ...rest, mainService });
    });

    const result = Object.entries(groupedData).map(
      ([mainService, details]) => ({
        mainService,
        details,
      })
    );
    return result;
  };

  const handleSubmitService = (e) => {
    if (currentState === "edit") {
      dispatch(serviceUpdating(currentData?._id, e));
    } else {
      dispatch(postService(e));
    }
    handleToggleBackdrop({}, "");
  };

  const Service = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      {/* <MDAvatar src={image} name={name} size="sm" /> */}
      <MDBox ml={2} lineHeight={1}>
        <MDTypography
          display="block"
          variant="button"
          fontWeight="medium"
          sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
        >
          {name}
        </MDTypography>
        {/* <MDTypography variant="caption">{email}</MDTypography> */}
      </MDBox>
    </MDBox>
  );

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography
        display="block"
        variant="caption"
        sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
        fontWeight="medium"
      >
        {title}
      </MDTypography>
      {/* <MDTypography variant="caption">{description}</MDTypography> */}
    </MDBox>
  );

  function renderRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        service: (
          <Link to={`/products/service/${item?._id}`} state={{ item }}>
            <Service
              key={index}
              // image={item.supplierLogo}
              name={item?.service}
              // email={item.email}
            />
          </Link>
        ),
        main: <Job title={item?.mainService} description="" />,
        description: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {item?.description}
          </MDTypography>
        ),
        products: (
          <Link to={`/products/service/${item?._id}`} state={{ item }}>
            <Chip
              label="View Products"
              variant="outlined"
              color="info"
              sx={{ fontWeight: "bold" }}
            />
          </Link>
        ),
        action: (
          <>
            <Chip
              label="Edit"
              variant="outlined"
              color="info"
              sx={{ fontWeight: "bold" }}
              onClick={() => handleToggleBackdrop(item, "edit")}
            />
          </>
        ),
      };
      values.push(newElement);
    });
    return values;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox pt={3}>
              <MDBox p={2} mt="auto" display="flex" justifyContent="end">
                <MDButton
                  component="a"
                  href="#"
                  rel="noreferrer"
                  variant="gradient"
                  color="light"
                  onClick={() =>
                    handleToggleBackdrop(
                      {
                        mainService: "",
                        service: "",
                        description: "",
                      },
                      ""
                    )
                  }
                >
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;New Service
                </MDButton>
              </MDBox>

              <DataTable
                table={{
                  columns: [
                    {
                      Header: "service",
                      accessor: "service",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "main service",
                      accessor: "main",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "description",
                      accessor: "description",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "products",
                      accessor: "products",
                      width: "20%",
                      align: "center",
                    },
                    {
                      Header: "action",
                      accessor: "action",
                      width: "20%",
                      align: "center",
                    },
                  ],

                  rows: renderRows(servicesList),
                }}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={true}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Service Config"
        onCompleteConfig={handleSubmitService}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Main Service Name",
            placeholderType: "Enter Main Service Name",
            dataType: "text",
            keyType: "mainService",
            valueType: currentData?.mainService,
          },
          {
            labelType: "Service Name",
            placeholderType: "Enter Service Name",
            dataType: "text",
            keyType: "service",
            valueType: currentData?.service,
          },
          {
            labelType: "Description",
            placeholderType: "Enter Description",
            dataType: "text",
            keyType: "description",
            valueType: currentData?.description,
          },
        ]}
        state={currentState}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Services;
